import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { supabase } from './lib/supabase';

const Proveedores = require('./pages/Proveedores').default;
const Historial = require('./pages/Historial').default;
const Reportes = require('./pages/Reportes').default;
const Login = require('./pages/Login').default;
const Dashboard = require('./pages/Dashboard').default;
const CajaDiaria = require('./pages/CajaDiaria').default;
const Empleados = require('./pages/Empleados').default;
const Impuestos = require('./pages/Impuestos').default;

function App() {
  const [session, setSession] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setLoading(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });
    return () => subscription.unsubscribe();
  }, []);

  if (loading) return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'100vh', background:'#1B2631' }}>
      <p style={{ color:'white', fontSize:18 }}>Cargando...</p>
    </div>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!session ? <Login /> : <Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={session ? <Dashboard session={session} /> : <Navigate to="/login" />} />
        <Route path="/caja-diaria" element={session ? <CajaDiaria session={session} /> : <Navigate to="/login" />} />
        <Route path="*" element={<Navigate to={session ? "/dashboard" : "/login"} />} />
        <Route path="/historial" element={session ? <Historial session={session} /> : <Navigate to="/login" />} />
        <Route path="/reportes" element={session ? <Reportes session={session} /> : <Navigate to="/login" />} />      
        <Route path="/proveedores" element={session ? <Proveedores session={session} /> : <Navigate to="/login" />} />
        <Route path="/empleados" element={session ? <Empleados session={session} /> : <Navigate to="/login" />} />
        <Route path="/impuestos" element={session ? <Impuestos session={session} /> : <Navigate to="/login" />} />  
      </Routes>
    </BrowserRouter>
  );
}

export default App;